import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function IcsSecurity() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div className="breadcrumbs">
                                    <ul>
                                        <li><Link to="/"><span>Home</span></Link><meta content="1" /></li>
                                        <li><i className="icofont-thin-right"></i><span>ICS Security</span><meta content="2" /></li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Industrial Cybersecurity</div>
                                <h1 className="prod-hero-title">Launch Your <span>Industrial Cybersecurity</span> Program</h1>
                                <p>Protect critical industrial infrastructure with engineering-grade security solutions designed for OT/ICS environments — where traditional IT security simply doesn't fit.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg-transparant.webp')} alt="ICS Security" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Overview */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/ics.jpeg')} alt="Industrial Cyber Security" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">The Challenge</div>
                                <h2>Industrial Cybersecurity is Unique</h2>
                                <p>Launching a cybersecurity initiative for industrial networks is far more complex than for traditional IT networks. IT security practices don't seamlessly align with industrial systems — patching is a recurring challenge, antivirus solutions often don't fit, and even basic security measures have their own set of problems.</p>
                                <p>Getting both IT and engineering experts to collaborate on cybersecurity issues is often a tough hurdle. CLOUD MIND bridges this gap with specialized industrial security expertise.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Talk to Experts <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* What you get */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>What You Get</div>
                        <h2 className="prod-section-title">With CLOUD MIND <span>You Get</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Engineering-grade protection through Unidirectional Gateways that physically cannot be breached</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/products/icons/ics-1.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Industrial-Grade Protection</h4>
                            <p>Unidirectional Gateways offer engineering-grade protection against cyber attacks. No matter how advanced, a cyber attack cannot breach unidirectional hardware — physical security guaranteed.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/products/icons/ics-2.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Business Efficiencies</h4>
                            <p>Unidirectional Gateways create secure copies of industrial OPC, historian, and other servers for IT networks. IT users and applications access these copies as usual, enabling business automation while maintaining safety.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/products/icons/ics-3.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Cloud Connections</h4>
                            <p>Unidirectional Cloud Gateways provide the advantages of vendor and cloud connectivity without the security risks of firewalls — collecting, translating, and securely transmitting industrial data to cloud systems.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Industry Use Cases */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Industry Use Cases</div>
                        <h2 className="prod-section-title">Protecting Critical <span>Infrastructure</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Unidirectional Gateways protect the most critical industrial environments across every sector</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-bolt"></i></div>
                            <h4>Power Plants</h4>
                            <p>Remote cyber attacks cannot penetrate Unidirectional Gateways to compromise control systems critical for worker and public safety, protecting turbines and ensuring continuous electricity production.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-tint"></i></div>
                            <h4>Oil &amp; Gas</h4>
                            <p>Offshore platforms, pipelines, and refineries stay protected — no cyber-sabotage attack can breach hardware, safeguarding workers, the environment, equipment, and production continuity.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-train"></i></div>
                            <h4>Rail &amp; Metro Systems</h4>
                            <p>Switching systems, electric power systems, and operations control centers are protected from cyber attacks originating on IT or Internet networks — regardless of sophistication.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-building"></i></div>
                            <h4>Critical Facilities</h4>
                            <p>Data centers, airports, government and military campuses — Unidirectional Gateways are impervious to attacks from Internet-exposed IT networks, ensuring continuous connected operations.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-faucet"></i></div>
                            <h4>Water Treatment</h4>
                            <p>Municipal leaders can be confident that automation systems and water treatment infrastructure will operate continuously and correctly, even against the most sophisticated cyber attacks.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-industry"></i></div>
                            <h4>Manufacturing</h4>
                            <p>Neither ransomware nor the most sophisticated Internet-based attacks can breach the system, ensuring no threat to product quality or the continuity and accuracy of manufacturing operations.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Secure Your Industrial Infrastructure Today</h3>
                            <p>Get a comprehensive ICS/OT cybersecurity assessment and protection plan for your critical operations.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
